// Every project's scheduled-runs switch, the one each project's Settings tab carries.
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

import {
  type TeamSettingsProject,
  type SwitchCosts,
  useSetProjectLearningAgents,
} from "../api/hooks/useAgentPortfolio";
import { ProjectEnablementList } from "../components/ProjectEnablementList";
import { SettingSubcard } from "../components/SettingSubcard";
import { scheduledRunsWarning, usdRange } from "../components/switchCostWarnings";
import { perTick } from "../utils/projectEnablement";
import styles from "./TeamSettingsTab.module.css";

export const TeamScheduledRuns = ({
  alwaysOn,
  projects,
  switchCosts,
}: {
  alwaysOn: string;
  projects: TeamSettingsProject[];
  switchCosts: SwitchCosts;
}) => {
  const { user } = useKindeAuth();
  const mutation = useSetProjectLearningAgents();
  const costs = projects.flatMap((p) =>
    p.scheduled_runs || p.runs_on_usd === null ? [] : [p.runs_on_usd],
  );
  return (
    <SettingSubcard
      title="Scheduled runs"
      describe={`${alwaysOn} and each project's enabled specialists work every project whose scheduled runs are on.`}
      warning={costs.length > 0 ? scheduledRunsWarning(switchCosts, usdRange(costs)) : null}
    >
      <ProjectEnablementList
        rows={projects.map((p) => ({
          project_id: p.project_id,
          project_name: p.project_name,
          on: p.scheduled_runs,
          detail: !p.scheduled_runs && p.runs_on_usd !== null && (
            <span className={styles.cost}>~${p.runs_on_usd} first run</span>
          ),
        }))}
        saving={perTick(mutation)}
        offHeading="Disabled"
        allOn="Enabled for every project."
        onChange={(project_id, enabled) =>
          mutation.mutate({ project_id, enabled, actor_email: user?.email ?? "" })
        }
      />
    </SettingSubcard>
  );
};
